/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import {getSalesOrgAll, getDetailRole} from '../../../api/modules/master-data/master_2'
import Pagination from '../component/Pagination'
import swal from 'sweetalert'
import {getAccessesRole} from '../../../api/modules/access/access'
import {MultiSelect} from 'react-multi-select-component'
import {Spinner} from 'react-bootstrap'
import {RowFilter} from './RowFilter'
import {fetchRoles, headers} from '../../../services/fetcher'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {objToParams} from '../../../utils/objToParams'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {
  filterSelector,
  setFilterRole,
  resetFilterRole,
  setIsFetchData,
} from '../../../redux/slices/filterSlices'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {StyledCard} from '../../../components/StyledCard'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'

type Props = {
  className: string
}

const TableRole: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterRole} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 4,
    onReloadTable: () => handleResetTable(),
  })

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [role, setRole] = useState<any>()
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [salesOrg, setSalesOrg] = useState<any[]>([])
  const [getSaleses, setgetSaleses] = useState<any>([])
  const [isError, setIsError] = useState(false)

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)
      const token = localStorage.getItem('token')
      const endpoint = `${url}&${objToParams(filterRole)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setRole(data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const [accesses, setAccesses] = useState<any>()

  useEffect(() => {
    const getSalesOrg = async () => {
      setLoading(true)
      const res = await getSalesOrgAll()
      const data = res.data.data
      setSalesOrg(data)
      setLoading(false)
    }

    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesRole(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
    getSalesOrg()
  }, [])

  const [name, setName] = useState<any>('')
  const [sales, setSales] = useState<any>('')
  const [flag, setFlag] = useState<any>('')
  const [isUpload, setIsUpload] = useState(false)

  // const clearState
  const clearState = () => {
    setName('')
    setSales('')
    setFlag('')
    setIsUpload(false)
  }

  const postRole = async () => {
    setBtnLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/role/create`,
        {
          name: name,
          sales_org_code: sales,
          flag: flag,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        swal({
          title: `${t('role created successfully')}`,
          icon: 'success',
        })
        handleClose()
        clearState()
        onFetchRole()
        setgetSaleses([])
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const deleteRole = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          axios
            .delete(`${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/role/delete/${id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then((response) => {
              swal({
                title: `${t('Role Deleted Successfully')}`,
                icon: 'success',
              }).then(() => {
                setActived(!actived)
              })
              setIsUpload(true)
            })
            .catch((error) => {
              swal({
                title: `${t('Data Failed to Delete')}`,
                icon: 'error',
              })
            })
        }
      })
      .catch((error) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const [editId, setEditId] = useState<any>('')
  const [editName, setEditName] = useState<any>('')
  const [editSalesName, setEditSalesName] = useState<any>('')
  const [editFlag, setEditFlag] = useState<any>('')

  const handleEdit = async (id: any) => {
    handleShow1()
    setEditId(id)
    const res = await getDetailRole(id)
    const data = res.data.data

    const selectedSales = res.data.data.sales_orgs.map((item: any) => ({
      value: item.code,
      label: item.name,
    }))

    setEditName(data.name)
    setSales(data.sales_org_code?.split('|'))
    setEditSalesName(selectedSales)
    setEditFlag(data.flag)
  }

  const editRole = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/role/edit/${editId}`,
        {
          name: editName,
          sales_org_code: editSalesName,
          flag: editFlag,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        swal({
          title: `${t('Role Edited Successfully')}`,
          icon: 'success',
        })
        handleClose1()
        setActived(!actived)
        setgetSaleses([])
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleChange = async (event: any) => {
    // console.log(event);
    setgetSaleses([...event])
    const selectedSales = [...event].map((item: any) => item.value)
    let getSalesesValue = selectedSales.join(',')
    setSales(selectedSales)
  }

  // console.log(editSalesName)

  //#region state for search
  const [actived, setActived] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filterRole?.per_page ?? 5
    return page * per - per
  }, [filterRole, page])

  const onFetchRole = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchRoles(filterRole)
      .then((res) => {
        setRole(res.data.data)
        setNumberURL(res.data.data.links)
        setPage(res.data.data.current_page)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterRole])

  useEffect(() => {
    const getData = setTimeout(onFetchRole, 1000)
    return () => clearTimeout(getData)
  }, [onFetchRole])
  //#endregion

  const [flagList, setFlagList] = useState<any[]>([
    {value: 'finance', label: 'Finance'},
    {value: 'admin', label: 'Admin'},
    {value: 'salesAdmin', label: 'Sales Admin'},
    {value: 'salesAnper', label: 'Sales Anper'},
    {value: 'otorisator', label: 'Otorisator'},
  ])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterRole({...filterRole, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterRole())
  }

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterRole?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          hakAkses?.create && (
            <button onClick={handleShow} className='btn btn-primary d-flex align-items-center'>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              <p>{t('kontrak-tambah') + ' Role'}</p>
            </button>
          )
        }
      />

      {hakAkses?.read && (
        <>
          <TableUI.TableWrapper>
            <TableUI.Table>
              <TableUI.THead>
                <tr>
                  <th>{t('No')}</th>
                  <th>{t('nama')}</th>
                  <th>Sales Org</th>
                  <th>{t('order-aksi')}</th>
                </tr>
              </TableUI.THead>

              <TableUI.TBody>
                <RowFilter />
                {loading ? (
                  <RowLoader />
                ) : isError ? (
                  <RowErrorFetch />
                ) : role?.data?.length === 0 ? (
                  <RowEmptyData />
                ) : (
                  role?.data?.map((item: any, index: number) => (
                    <tr key={item?.name ?? index}>
                      <td>{index + 1 + rowNumber}</td>
                      <td>{item.name.replace(/ for /i, ' ' + t('untuk') + ' ')}</td>
                      <td>
                        <div className='d-flex flex-wrap justify-content-center w-100'>
                          {item.sales_orgs?.map((item: any, _index: number) => {
                            return (
                              <span
                                key={item?.name ?? index}
                                className='badge text-bg-primary me-1 mb-1 text-white'
                              >
                                {item?.name}
                              </span>
                            )
                          })}
                        </div>
                      </td>
                      <td>
                        <div className='d-flex justify-content-center'>
                          {hakAkses?.update && (
                            <>
                              <button
                                onClick={() => handleEdit(item.id)}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('ubah')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/pencil-fill.svg'
                                  className='svg-icon-3'
                                />
                              </button>
                            </>
                          )}
                          {hakAkses?.delete && (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title={t('Hapus')}
                              onClick={() => deleteRole(item.id)}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </TableUI.TBody>
            </TableUI.Table>
          </TableUI.TableWrapper>

          <Pagination paginate={paginateNumber} test={numberURL} />
        </>
      )}

      <Modal
        show={show1}
        onHide={handleClose1}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('nama')}</Form.Label>
            <Form.Control
              type='text'
              value={editName}
              onChange={(e: any) => setEditName(e.target.value)}
            />
          </Form.Group>
          {/* <Form.Group className='mb-3' controlId='formBasicEmail'>
                                        <Form.Label>Sales Org</Form.Label>
                                        <Form.Select
                                          aria-label='Default select example'
                                          onChange={(e: any) => setEditSales(e.target.value)}
                                        >
                                          <option selected value={editSales}>
                                            {editSalesName}
                                          </option>
                                          {salesOrg?.map((item: any) => (
                                            <option value={item.code}>{item.name}</option>
                                          ))}
                                        </Form.Select>
                                      </Form.Group> */}
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Sales Org</Form.Label>
            {salesOrg != null ? (
              <MultiSelect
                options={salesOrg?.map((item: any) => {
                  return {label: item.name, value: item.code}
                })}
                value={editSalesName}
                onChange={setEditSalesName}
                labelledBy='Select'
              />
            ) : null}
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Flag')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={(e: any) => setEditFlag(e.target.value)}
            >
              {flagList?.map((item: any) => (
                <>
                  {editFlag == item.value ? (
                    <option selected>{editFlag}</option>
                  ) : (
                    <option value={item.value}>{item.label}</option>
                  )}
                </>
              ))}
            </Form.Select>
          </Form.Group>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={editRole} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('ubah')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('order-tambah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('nama')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('nama')}
              onChange={(e: any) => setName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Sales Org</Form.Label>
            {salesOrg != null ? (
              <MultiSelect
                options={salesOrg?.map((item: any) => {
                  return {label: item.name, value: item.code}
                })}
                value={getSaleses}
                onChange={handleChange}
                labelledBy='Select'
              />
            ) : null}
          </Form.Group>
          {/* <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>Sales Org</Form.Label>
                        <Form.Select
                          aria-label='Default select example'
                          onChange={(e: any) => setSales(e.target.value)}
                        >
                          <option>{t('pilih')} Sales Org</option>
                          {salesOrg?.map((item: any) => (
                            <option value={item.code}>{item.name}</option>
                          ))}
                        </Form.Select>
                      </Form.Group> */}
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Flag')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={(e: any) => setFlag(e.target.value)}
            >
              <option value=''>
                {t('pilih')} {t('Flag')}
              </option>
              {flagList?.map((item: any, index: number) => (
                <option key={item?.value ?? index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={postRole} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                t('order-tambah')
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableRole}
